<template>
    <el-row class="grid-stack-item">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <div class="header">
                <h1>{{ $t('Folder') }}</h1>
            </div>
            <div class="my-content">
                <div class="grid-stack-item-content" element-loading-background="rgba(0, 0, 0, 0.8)" v-loading.body="fullscreenLoading">
                    <iframe @load="fullscreenLoading=false" :src="'https://drive.google.com/embeddedfolderview?id='+$route.params.id+'#list'" style="width:100%; height:600px; border:0;"></iframe>
                </div>
            </div>
        </el-col>
    </el-row>
</template>
<script>
    export default {
        data() {
            return {
                fullscreenLoading: true
            };
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/Layout/FileManager/FolderIframe.vue